import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateWorkspaceSubscriptionPlan } from "api/services/workspace-service";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_SUBSCRIPTION_QUERY_KEY, WORKSPACE_STORAGE_USAGE_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useUpdateWorkspaceSubscriptionPlan = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: (planCode: string): Promise<void> =>
            updateWorkspaceSubscriptionPlan({ workspaceId, planCode }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_SUBSCRIPTION_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: WORKSPACE_STORAGE_USAGE_QUERY_KEY });
        },
    });

    return {
        changeSubscriptionPlan: mutation.mutateAsync,
        changingSubscriptionPlan: mutation.isPending,
    };
};
